var map = {
	"./esenin@128.webp": 9968,
	"./gallium@128.webp": 2145,
	"./matem@128.webp": 3049,
	"./physics@128.webp": 3055,
	"./pt@128.webp": 9485,
	"./tvorog@128.webp": 2788,
	"./universe-say@128.webp": 3985
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8138;